import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { cognitoAuth } from '../auth/cognito';

const API_URL = import.meta.env.VITE_API_URL || 'https://roniapi.data-corner.com.au';

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = await cognitoAuth.getIdToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    console.error('API Error:', error.response?.status, error.response?.data);

    if (error.response?.status === 401) {
      // Try to refresh token
      const refreshed = await cognitoAuth.refreshSession();
      if (refreshed && error.config) {
        // Retry the original request
        const token = await cognitoAuth.getIdToken();
        if (token) {
          error.config.headers.Authorization = `Bearer ${token}`;
          return apiClient.request(error.config);
        }
      }
      // If refresh failed, redirect to login
      window.location.href = '/panel/login';
    }

    if (error.response?.status === 403) {
      console.error('Access forbidden - check if user has super_admin role');
    }

    return Promise.reject(error);
  }
);

export { apiClient };
export default apiClient;
